import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Category } from '../models/category';
import { FirestoreService } from './firestore-utils/firestore.service';
import { ShopService } from './shop.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private currentCategories$ = new BehaviorSubject<Category[]>(null);

  constructor(
    private firestoreService: FirestoreService,
    private shopService: ShopService
  ) {
    this.observeCurrentShop();
  }

  private observeCurrentShop() {
    this.shopService.getCurrentShop().subscribe(async (shop) => {
      if (!shop) { return this.currentCategories$.next(null); }

      const categories = await this.getCategoriesByShop(shop.uid);
      this.currentCategories$.next(categories);
    });
  }

  getCurrentCategories() {
    return this.currentCategories$.asObservable().pipe(map(categories => categories || [] ));
  }

  getCategory(uid: string): Promise<Category> {
    return this.firestoreService.getRecord('shop-categories', uid) as Promise<Category>;
  }

  getCategoriesByShop(shopId: string): Promise<Category[]> {
    return this.firestoreService.getRecordsByProperty('shop-categories', 'shopId', '==', shopId) as Promise<Category[]>;
  }

  getCategories(): Promise<Category[]> {
    return this.firestoreService.getCollection('shop-categories');
  }

  addCategory(category: Category): Promise<Category> {
    console.log('Adding category', category);
    return this.firestoreService.addOrUpdateRecord('shop-categories', JSON.parse(JSON.stringify(category))) as Promise<Category>;
  }

  updateCategory(category: Category): Promise<Category> {
    return this.firestoreService.addOrUpdateRecord('shop-categories', JSON.parse(JSON.stringify(category))) as Promise<Category>;
  }

  removeCategory(uid: string) {
    return this.firestoreService.removeRecord('shop-categories', uid);
  }

  observeCategory(uid: string): Observable<Category> {
    return this.firestoreService.observeRecord('shop-categories', uid);
  }

  observeCategories(): Observable<Category[]> {
    return this.firestoreService.observeCollection('shop-categories');
  }

}
